(function(){

	angular
		.module('ngmvac')
		.factory('Cart', Cart);

	Cart.$inject = ['$rootScope', '$http'];

	function Cart($rootScope, $http) {
		var cartContent = [];
		var taxes = {
			amount: 0,
			currency: ''
		};
		var total = 0;
		var config = {
			editable: false,
			viewTotal: true
		};
		var cupon = {};

		return {
			cupon: cupon,
			content: cartContent,
			total: total,
			add: add,
			addToSession: addToSession,
			get: get,
			remove: remove,
			config: config,
			on: subscribe,
			init: init,
			getTime: getTime,
			getPaymentCart: getPaymentCart,
			taxes: taxes
		};

		function get() {
			return cartContent;
		}

		function add(data, callback) {
			console.log(data, "data");
			if (!data.hasOwnProperty('price')) {
				throw "El objeto debe tener una propiedad price";
				return false;
			}

			if (!data.hasOwnProperty('content')) {
				throw "El objeto debe tener una propiedad content";
				return false;
			}

			cartContent.push(data);

			addToSession(data)
				.then(function (response) {
					data.loaded = true;
					if (typeof callback === 'function') {
						callback(data);
					}
					//console.log(cartContent);
					$rootScope.$broadcast('itemCartAdded', {total: getTotal(), item: data});
				});
		}

		function _add(data) {
			console.log(data, "data");
			if (!data.hasOwnProperty('price')) {
				throw "El objeto debe tener una propiedad price";
				return false;
			}

			if (!data.hasOwnProperty('content')) {
				throw "El objeto debe tener una propiedad content";
				return false;
			}

			cartContent.push(data);
			$rootScope.$broadcast('itemCartAdded', {total: getTotal(), item: data});
		}

		function remove(index) {
			var objDeleted = null;
			cartContent[index].loaded = false;
			deleteFromSession({index: index})
				.then(function (response) {
					//console.log(index);
					objDeleted = cartContent.splice(index, 1);
					$rootScope.$broadcast('itemCartDeleted', {total: getTotal(), item: objDeleted});
				});

		}

		function getTotal() {
			var sum = 0;

			angular.forEach(cartContent, function (package) {
				sum += package.price;
			});

			return sum; // + taxes.amount;
		}

		function notifyChange() {
			
			/*for (var i = 0; i < callbacks['change'].length; i++) {
				callbacks['change'][i]({
					total: getTotal()
				});
			}*/

			// total = getTotal;
		}

		function subscribe(chanel, callback) {
			callbacks[chanel].push(callback);
		}

		function init() {

			getFromSession()
				.then(function (response) {
					// console.log('getFromSession:',response.data.items);
					var data = response.data.items;
					taxes.amount = response.data.taxes.amount;
					taxes.currency = response.data.taxes.currency;

					// Se adapta la información para agregar al carrito
					angular.forEach(data, function (item) {
						switch (item.type) {
							case 'hotel':
								adapHotel(item);
							break;
							case 'auto':
								adapAuto(item);
							break;
						} 
					});

					$rootScope.$broadcast('cartLoaded', {total: getTotal(), content: cartContent});
				});
		}

		function addToSession(data) {
			// console.log('addcar:',data);
			return $http.post('/cart/add', data);
		}

		function getFromSession() {
			return $http.get('/cart/get');
		}

		function deleteFromSession(data) {
			return $http.post('/cart/delete', data);
		}

		function adapHotel(hotelSelection) {
			// console.log(hotelSelection);
			// var nights = moment(moment(hotelSelection.stay.checkOut).format('YYYY-MM-DD')).diff(moment(hotelSelection.stay.checkIn).format('YYYY-MM-DD'));
			var diff 	 = moment(hotelSelection.stay.checkOut, 'YYYY-MM-DD').diff(moment(hotelSelection.stay.checkIn, 'YYYY-MM-DD'), 'days');			
			var hotelAdapter = {
				type: 'hotel',
				code: hotelSelection.code,
				tokenName: hotelSelection.tokenName,
				name: hotelSelection.name,
				categoryCode: hotelSelection.categoryCode,
				categoryName: hotelSelection.categoryName,
				startDate: hotelSelection.stay.checkIn,
				endDate: hotelSelection.stay.checkOut,
				zoneName: hotelSelection.zoneName,
				destinationName: hotelSelection.destinationName,
				images: hotelSelection.content.images,
				price: 0,
				content: [],
				packageSelectedTitle: hotelSelection.packageSelectedTitle,
				allPaxes: hotelSelection.allPaxes,
				check: hotelSelection.check,
				currency : hotelSelection.currency,
				nights : diff,
				boardt:"",
				upgradeAuto: [],
				discount: hotelSelection.discount
			};
			//console.log(hotelSelection.rooms, "ROOMS-CART")
			angular.forEach(hotelSelection.packageGrouped, function (packageGroup) {
				angular.forEach(packageGroup, function (hotelPackage) {
					hotelAdapter.price += hotelPackage.price;
					hotelAdapter.cancellationPenalty = hotelPackage.cancellationPenalty;
					hotelAdapter.cancellationpenaltyDays = hotelPackage.cancellationpenaltyDays;
					angular.forEach(hotelPackage.rooms, function (room) {
						hotelAdapter.boardt = room.boardName;
						hotelAdapter.content.push({
							rateKey: room.rateKey,
							rateCommentsId: room.rateCommentsId,
							cancellationPolicies: room.cancellationPolicies,
							allotment : room.allotment,
							name: room.roomName,
							roomCode : room.roomCode,
							adults: room.adults,
							children: room.children,
							boardCode: room.boardCode,
							net: room.net,
							childrenAges: room.childrenAges,
							amount: room.rooms,
							type: room.boardName,
							price: room.publicRate,
							discount: hotelAdapter.discount,
							discount_price: parseFloat(((room.publicRate / 1.19) * 100) / (100 - hotelAdapter.discount))
						});
					});
					if (hotelPackage.hasOwnProperty('car')) {
						if(hotelPackage.car){
							hotelAdapter.car = hotelPackage.car;
							hotelAdapter.upgradeAuto = hotelPackage.upgrade;
						}
					}
				});
			});
			//console.log(hotelAdapter);
			_add(hotelAdapter);
		}

		function adapAuto(auto) {
			_add(auto);
		}

		function getTime() {
			return $http.get('/cart/time');
		}

		function getPaymentCart(tokenId) {
			return $http.post('/payment/cart', {tokenId: tokenId});
		}
	}

})();